import ResponseStore from "@shared/stores/ResponseStore";

const PaymentMethodStore = {
  data: {
    paymentMethods: [],
    paymentMethod: {}
  },

  methods: {
    async fetchPaymentMethods (tenantId) {
      const response = await fetch(`/api/v4/tenants/${tenantId}/payment_methods`);
      const responseJSON = await response.json();

      return responseJSON.payment_methods;
    },

    async fetchAllPaymentMethods () {
      const response = await fetch("/api/v4/payment_methods/all");
      const responseJSON = await response.json();

      return responseJSON.payment_methods;
    },

    async fetchPaymentMethod (tenantId, paymentMethodId) {
      const response = await fetch(
        `/api/v4/tenants/${tenantId}/payment_methods/${paymentMethodId}`
      );

      const responseJSON = await response.json();

      return responseJSON.payment_method;
    },

    async createPaymentMethod (tenantId) {
      let response = await fetch(`/api/v4/tenants/${tenantId}/payment_methods`, {
        body: new FormData(document.getElementById("form-card")),
        method: "POST"
      });

      ResponseStore.finishProcessing();

      return response.json();
    },

    async updatePaymentMethod (tenantId, paymentMethodId) {
      let response = await fetch(
        `/api/v4/tenants/${tenantId}/payment_methods/${paymentMethodId}`, {
          body: new FormData(document.getElementById("form-card")),
          method: "PUT"
        }
      );

      ResponseStore.finishProcessing();

      return response.json();
    },

    async filter (countryId, currencyId, tenantId) {
      let response = await fetch(
        `/api/v4/payment_methods/filter?country_id=${countryId}&currency_id=${currencyId}&tenant_id=${tenantId}`
      );

      return response.json();
    }
  }
};

export default PaymentMethodStore;
